import { View } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { MultiLineInputViewModel } from "./multiLineInput-viewModel"

export class MultiLineInputView extends FormBuilderComponentView<MultiLineInputViewModel>{
    GetViewUniqueId(): string {
        return "V-5A40F919-0328-4912-94DD-111989720229"
    }
    loadHtml(): string {
        let element = require('./multiLineInput.html').default;
        let style = require('./multiLineInput.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Text(v: string) { this._Text = v; } public get Text(): string { return this._Text;} private _Text: string;
    public set ReadOnly(v: boolean) { this._ReadOnly = v; } public get ReadOnly(): boolean { return this._ReadOnly;} private _ReadOnly: boolean;
    public set IsNumeric(v: boolean) { this._IsNumeric = v; } public get IsNumeric(): boolean { return this._IsNumeric;} private _IsNumeric: boolean;
    public set MaxLength(v: number) { this._MaxLength = v; } public get MaxLength(): number { return this._MaxLength;} private _MaxLength: number;
    public set RowsHeight(v: number) { this._RowsHeight = v; } public get RowsHeight(): number { return this._RowsHeight;} private _RowsHeight: number;

}
